import React, {useContext, useEffect, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import {Context} from "./..";
import { getProducts } from "../http/productAPI";




const Brands = ({ filters }) => {
      const { product, user } = useContext(Context);
      const [filtersLoaded, setFiltersLoaded] = useState(false);    

    // делаем запрос на сплит системы что бы получить фильтра по всем брендам
      useEffect(() => {     
    
          const selectedFolderFilters = product.requestBodyFilter;
          product.setSelectedFolder({ id: "2" });
          getProducts(product.selectedFolder.id, 0, 20, selectedFolderFilters)
            .then(data => {
                product.setProducts(data.products);
                product.setFilters(data.filters);
                setFiltersLoaded(true);
            })
            .catch(error => {
                console.log("Ошибка при получении продуктов: Brands useEffect", error);
            });
      }, [user, product]);
      if (!filtersLoaded) return null;
  // Ищем фильтр "Бренд"
 const brandFilter = product.filters.find(f => f.name === "Бренд"); 
 
 const createBrandLink = (brandName) => {
    const encodedBrand = encodeURIComponent(brandName);
    const filterName = encodeURIComponent("Бренд");
    return `/catalog/wall_split_system?${filterName}=${encodedBrand}`;
  };


  return (
    <Container className="my-4">
      <h4 className="mb-3">Популярные бренды</h4>
      <Row>
        {brandFilter.values.map((brand, index) => (
          <Col key={brand.name} xs={6} md={2} className="mb-4 d-flex justify-content-center">
            <div className="text-center">
              <a 
                href={createBrandLink(brand.name)}
                style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}
              >
                <Image
                  src={`/images/brands/${brand.name.toLowerCase()}.jpg`}
                  alt={`Бренд ${brand.name}`}
                  style={{ maxWidth: "100px", height: "auto", objectFit: "contain" }}
                />
                <div className="mt-2">{brand.name}</div>
              </a>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Brands;